import React, { useState, useCallback } from "react";
import { Form, Checkbox, Dropdown } from "semantic-ui-react";
import { producaov2 as api } from "../../../../../services/apis";
import { cupomSchema } from "../../Validation/CupomValidation";

import swal from "sweetalert";
import {
  StyledLabel,
  StyledButton,
  ContainerLimitante,
  StyledCheckbox,
  StyledLabelRed,
  StyledCheck,
  StyledCheckboxLeft,
} from "./styles";
import AlunosSelector from "../../../AlunosSelector";
import TreinamentosSelector from "../../../TreinamentosSelector";
import TreinamentoSearchInputMultiple from "./TreinamentoSearchInputMultiple";

const Formulario = () => {
  const [cupom, setCupom] = useState({
    codigo: [],
    desconto: 1,
    descricao: "",
    maxUso: 0,
    dataVencimento: "",
    emails: [],
  });

  const [porcent, setPorcent] = useState(1);
  const [valor, setValor] = useState(0);
  const [validade, setValidade] = useState(null);
  const [acumulaDesconto, setAcumulaDesconto] = useState(false);

  const [treinamentos, setTreinamentos] = useState([]);
  const [treinamentoIds, setTreinamentosIds] = useState([]);

  const [aluno, setAluno] = useState(0);

  const [codigoAlfab, setCodigoAlfab] = useState();
  const [numCodigo, setNumCodigo] = useState();

  const [multipleCodes, setMultipleCodes] = useState(false);
  const [customValidade, setCustomValidade] = useState(false);
  const [numMaxUsosDeterminado, setNumMaxUsosDeterminado] = useState(false);
  const [dataVencimentoDeterminada, setDataVencimentoDeterminada] =
    useState(false);

  const [aplicavel, setAplicavel] = useState([]);
  const [validadeCurso, setValidadeCurso] = useState(0);
  const [validadeIsNumber, setValidadeIsNumber] = useState(true);
  const [loading, setLoading] = useState(false);

  const utils = [
    {
      key: 0,
      text: "Indeterminado",
      value: null,
    },
    {
      key: 1,
      text: "Determinado",
      value: "Determinado",
    },
  ];

  const utilsPayment = [
    {
      key: 1,
      text: "PicPay",
      value: "picpay",
    },
    {
      key: 2,
      text: "Cartão de Crédito",
      value: "cartao_de_credito",
    },
    {
      key: 3,
      text: "Bitcoin",
      value: "bitcoin",
    },
  ];

  const handleValidade = useCallback(e => {
    const { value } = e.target;

    setValidade(value);
    // setValidadeCurso(0);
  }, []);

  const handleValidadeCurso = useCallback(e => {
    const { value } = e.target;

    setValidadeCurso(value);
    // setValidade("");
  }, []);

  const handleCupom = useCallback(
    e => {
      const newCupom = { ...cupom };
      const { name, value } = e.target;
      newCupom[name] = value;
      setCupom(newCupom);
    },
    [cupom]
  );

  const handleAlunoChange = value => {
    setAluno(value);
  };

  const handleInputChangeValor = e => {
    if (valor === 1) {
      setValor(0);
    }
    if (valor !== 1) {
      setValor(1);
      setPorcent(0);
    }
    return;
  };

  const handleInputChangePorcentagem = e => {
    if (porcent === 0) {
      setPorcent(1);
      setValor(0);
    }
    if (porcent !== 0) {
      setPorcent(0);
    }
    return;
  };

  const changedPay = e => {
    if (e.target.innerText === "PicPay") {
      aplicavel.push("picpay");
    }
    if (e.target.innerText === "Cartão de Crédito") {
      aplicavel.push("cartao_de_credito");
    }
    if (e.target.innerText === "Bitcoin") {
      aplicavel.push("bitcoin");
    }
    setAplicavel(aplicavel);
  };

  const handleChangedTreinamentos = treinamentos => {
    setTreinamentos(treinamentos);
  };

  const handleCursoChange = treinamentos => {
    setTreinamentos(treinamentos);
    setTreinamentosIds(treinamentos?.map(t => t.value));
  };

  const verifEmails = e => {
    const string = e.target.value;
    const emailsArray = string.split(" ");

    let ev = {
      target: {
        name: "emails",
        value: emailsArray,
      },
    };

    return handleCupom(ev);
  };

  const verifValor = e => {
    const valor = e.target.value;
    if (porcent === 1 && valor > 100) {
      swal("Por favor", "Digite um valor menor que 100%", "warning");
      return;
    }
    handleCupom(e);
  };

  function gerarCodigos() {
    let arrayCodigos = [];
    for (let i = 1; i <= numCodigo; i++) {
      arrayCodigos.push(`${codigoAlfab}${i}`);
    }
    let e = {
      target: {
        name: "codigo",
        value: arrayCodigos,
      },
    };

    return handleCupom(e);
  }

  const getPayload = useCallback(
    cupom => {
      return {
        codigo: cupom.codigo.toString().toUpperCase(),
        desconto: cupom.desconto,
        descricao: cupom.descricao,
        email: cupom.emails.toString(),
        treinamentos: treinamentoIds.toString(),
        aplicavel: aplicavel.toString(),
        ispercent: porcent,
        ativo: "S",
        max_uso: cupom.maxUso,
        id_pessoa: aluno,
        acumula_desconto: acumulaDesconto === true ? 1 : 0,
        validade:
          cupom.dataVencimento === "Indeterminado"
            ? "Indeterminado"
            : cupom.dataVencimento,
        data_validade: customValidade && !validadeIsNumber ? validade : null,
        validade_curso: customValidade && validadeIsNumber ? validadeCurso : 0,
      };
    },
    [
      customValidade,
      validadeIsNumber,
      treinamentos,
      aplicavel,
      porcent,
      aluno,
      acumulaDesconto,
      validade,
      validadeCurso,
    ]
  );

  const createCupom = useCallback(
    async cupom => {
      try {
        setLoading(true);

        const payload = getPayload(cupom);

        const isValid = await cupomSchema.isValid(payload);

        if (!isValid) {
          swal("Favor preencha todos os campos obrigatórios ", "", "warning");
          return;
        }
        await api
          .post("admin/cupons", payload, {
            headers: {
              access_token: `voitto-token ${localStorage.getItem(
                "oauth_token"
              )}`,
            },
          })
          .then(async () => {
            const logs = {
              local: "admin/cupons/criar",
              texto: `Gerou o cupom (${cupom.codigo}) com a seguinte justificativa: ${cupom.descricao})`,
            };
            await api.post("system_logs", {
              acao: JSON.stringify(logs),
            });
          });

        swal("Cupom criado ", "", "success");
      } catch (err) {
        console.error(err);

        const logs = {
          local: "admin/cupons/criar",
          texto: `Tentou gerar o cupom (${cupom.codigo}) com a seguinte justificativa: ${cupom.descricao}) - Erro: ${err}`,
        };

        await api.post("system_logs", {
          acao: JSON.stringify(logs),
        });

        swal("Erro ao criar cupom", err?.response?.data?.message ? err?.response?.data?.message : err?.message, "error");
      } finally {
        setLoading(false);
      }
    },
    [customValidade, getPayload]
  );

  const createCupons = useCallback(async () => {
    if (!multipleCodes) {
      createCupom(cupom);

      return;
    }

    cupom.codigo.map(async codigoString => {
      createCupom({ ...cupom, codigo: codigoString.toString() });
    });
  }, [multipleCodes, cupom, createCupom]);

  return (
    <Form>
      <Form.Field>
        <Checkbox
          label="Gerar múltiplos codigos?"
          onChange={() => setMultipleCodes(!multipleCodes)}
          checked={multipleCodes}
        />
        {multipleCodes && (
          <ContainerLimitante>
            <StyledLabel>Parte alfabética</StyledLabel>
            <Form.Input
              placeholder="ABCDEF"
              value={codigoAlfab}
              onChange={e => setCodigoAlfab(e.target.value)}
            />
            <StyledLabel>Número de códigos a serem gerados</StyledLabel>
            <Form.Input
              type="number"
              min="1"
              value={numCodigo}
              onChange={e => setNumCodigo(e.target.value)}
            />
            <StyledButton onClick={gerarCodigos}>Gerar códigos</StyledButton>
          </ContainerLimitante>
        )}
      </Form.Field>
      <Form.Field>
        <Checkbox
          label="Esse cupom terá a data de expiração do curso diferente da padrão?"
          onChange={() => setCustomValidade(!customValidade)}
          checked={customValidade}
        />
        {customValidade && (
          <>
            <ContainerLimitante>
              <Checkbox
                label="Inserir validade como número?"
                onChange={() =>
                  setValidadeIsNumber(validadeIsNumber => !validadeIsNumber)
                }
                checked={validadeIsNumber}
              />
            </ContainerLimitante>

            {validadeIsNumber ? (
              <ContainerLimitante>
                <StyledLabel title="Quantidade de dias que curso irá expirar após a compra do curso">
                  Dias para expiração
                </StyledLabel>
                <Form.Input
                  type="number"
                  value={validadeCurso}
                  onChange={handleValidadeCurso}
                />
              </ContainerLimitante>
            ) : (
              <ContainerLimitante>
                <StyledLabel title="Data precisa para expiração do curso">
                  Data de expiração do curso
                </StyledLabel>
                <Form.Input
                  type="date"
                  value={validade}
                  onChange={handleValidade}
                />
              </ContainerLimitante>
            )}
          </>
        )}
      </Form.Field>
      <Form.Field>
        <StyledLabel>Código </StyledLabel>
        <Form.Input
          name="codigo"
          placeholder="ABCDEF010"
          value={cupom.codigo}
          onChange={handleCupom}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Número máximo de usos</StyledLabel>
        <Dropdown
          placeholder="Indeterminado"
          fluid
          selection
          options={utils}
          onChange={e =>
            e.target.innerText === "Determinado"
              ? setNumMaxUsosDeterminado(!numMaxUsosDeterminado)
              : setNumMaxUsosDeterminado(false)
          }
        />
        {numMaxUsosDeterminado && (
          <ContainerLimitante>
            <Form.Input
              name="maxUso"
              type="number"
              min="1"
              value={cupom.maxUso}
              onChange={handleCupom}
            />
          </ContainerLimitante>
        )}
      </Form.Field>
      <Form.Field>
        <StyledLabel>Data de vencimento</StyledLabel>
        <Dropdown
          placeholder="Indeterminado"
          fluid
          selection
          options={utils}
          onChange={e =>
            e.target.innerText === "Determinado"
              ? setDataVencimentoDeterminada(!dataVencimentoDeterminada)
              : [setDataVencimentoDeterminada(false), handleCupom]
          }
        />
        {dataVencimentoDeterminada && (
          <ContainerLimitante>
            <Form.Input
              name="dataVencimento"
              type="date"
              value={cupom.dataVencimento}
              onChange={handleCupom}
            />
          </ContainerLimitante>
        )}
      </Form.Field>
      <Form.Field>
        <AlunosSelector handleChange={handleAlunoChange} />
      </Form.Field>
      <Form.Field>
        <StyledLabel>
          Desconto:
          <StyledCheck>
            <Checkbox
              label="Porcentagem"
              checked={porcent}
              onChange={e => handleInputChangePorcentagem()}
            />
            <StyledCheckboxLeft
              label="Valor"
              checked={valor}
              onChange={e => handleInputChangeValor()}
            />
          </StyledCheck>
        </StyledLabel>
        <Form.Input
          name="desconto"
          type="number"
          min="1"
          max={porcent === 1 ? "100" : "10000"}
          value={cupom.desconto}
          onChange={e => verifValor(e)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Aplicável em Pagamentos via:</StyledLabel>
        <Dropdown
          placeholder="Selecione os pagamentos"
          fluid
          multiple
          selection
          options={utilsPayment}
          onChange={e => changedPay(e)}
        />
      </Form.Field>
      <Form.Field>
        {/* <TreinamentosSelector
          multiple
          clearable
          // initialLoad
          handleChange={handleChangedTreinamentos}
        /> */}
        <TreinamentoSearchInputMultiple
          handleChange={handleCursoChange}
          selectedCursos={treinamentos}
          setSelectedCursos={setTreinamentos}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Descrição</StyledLabel>
        <StyledLabelRed>
          *Atenção: caso o cupom seja direcionado, será mostrado esse motivo ao
          usuário
        </StyledLabelRed>
        <Form.Input
          name="descricao"
          placeholder="Por que o cupom foi criado?"
          value={cupom.descricao}
          onChange={handleCupom}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>E-mail Responsável</StyledLabel>
        <Form.Input
          multiple
          selection
          value={cupom.emails}
          onChange={e => verifEmails(e)}
        />
      </Form.Field>
      {/* <StyledCheckbox
        label="Acumular desconto do cupom com descontos a vista."
        checked={acumulaDesconto}
        onChange={(e) =>
          acumulaDesconto == true
            ? setAcumulaDesconto(false)
            : setAcumulaDesconto(true)
        }
      /> */}
      <StyledButton loading={loading} onClick={createCupons}>
        <i class="plus icon"></i> Criar
      </StyledButton>
    </Form>
  );
};

export default Formulario;
